import { ManagementEntityEventModel } from '@data-layer/models/management';
import { DateHelper } from '@helpers/date.helper';

export class CbpMessageHelper {
  constructor() {}

  public static expired(timestamp: string, sendDate: string): boolean {
    if (!sendDate || !timestamp) {
      return false;
    }

    return DateHelper.isBefore(timestamp, sendDate);
  }

  public static sortMessages(messages: ManagementEntityEventModel[]) {
    return (messages || []).sort((a, b) => DateHelper.getTime(b.timestamp) - DateHelper.getTime(a.timestamp));
  }
}
